/** Browser-tab storage for the revocable local bearer session. */
const TOKEN_KEY = 'backoffice_session_token';

export function getStoredToken(): string | null {
  return sessionStorage.getItem(TOKEN_KEY);
}

export function setStoredToken(token: string): void {
  sessionStorage.setItem(TOKEN_KEY, token);
}

export function clearStoredToken(): void {
  sessionStorage.removeItem(TOKEN_KEY);
}

export async function acquireAccessToken(): Promise<string | null> {
  return getStoredToken();
}
